import axios from 'axios'
import config from '@/config'
import { interceptorRequestSetup, interceptorRequestError } from './interceptors/request'
import { interceptorResponseSuccess, interceptorResponseError } from './interceptors/response'

const http = axios.create({ baseURL: config.API_URL })

http.interceptors.request.use(interceptorRequestSetup, interceptorRequestError)
http.interceptors.response.use(interceptorResponseSuccess, interceptorResponseError)

const authorizeApi = token => {
  if (token) {
    http.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete http.defaults.headers.common.Authorization
  }
}

export default http
export { authorizeApi }
